import React from "react";
import "./invoiceShared.scss";
import appLogo from "../../Assets/images/enabill.png";
import vendorsConfig from "../../vendorsConfig";

function InvoiceSharedFooter({ text, brandImage = null, brandAlt = "brand", showAppLogo = true }) {
  console.log(process.env.REACT_APP_VENDOR);
  console.log(vendorsConfig);
  const vendorLogo = vendorsConfig.LOGO;
  const vendorAlt = vendorsConfig.NAME;
  return (
    <div className="invoice-shared-footer-note">
      <span className="invoice-shared-tiny-lock">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
          <path d="M7 10V8a5 5 0 1 1 10 0v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <rect x="5" y="10" width="14" height="10" rx="3" stroke="currentColor" strokeWidth="2" />
        </svg>
        {text}
        {showAppLogo ? <img src={brandImage ? brandImage : vendorLogo} alt={vendorAlt} width={50} className="mb-1" /> : null}
      </span>
    </div>
  );
}

export default InvoiceSharedFooter;